import {subscribe} from '@services/events'

const range = (n,min,max) => Math.min(Math.max(n,min),max)

export default function mouseProximity(
  {
    selector = '.mouse-proximity',
    smooth = 2,
    restThreshhold = 3,
    setGlobal = false
  } = {}
){
  if(Array.isArray(selector)){
    selector = selector.join(',');
  }

  let destroyed=false;

  let clientX = 0;
  let clientY = 0;

  let globalCurrentX = 0;
  let globalCurrentY = 0;

  const updateGlobal = ()=>{
    const newX = (clientX / window.innerWidth) * 2 - 1;
    const newY = (clientY / window.innerHeight) * 2 - 1;
    const oldX = globalCurrentX;
    const oldY = globalCurrentY;

    globalCurrentX += (newX - oldX) / smooth;
    globalCurrentY += (newY - oldY) / smooth;

    if(Math.abs(globalCurrentX - oldX).toFixed(restThreshhold) > 0){
      document.documentElement.style.setProperty('--mouse-x',globalCurrentX);
    }

    if(Math.abs(globalCurrentY - oldY).toFixed(restThreshhold) > 0){
      document.documentElement.style.setProperty('--mouse-y',globalCurrentY);
    }

  }

  const elements = Array.from(document.querySelectorAll(selector));

  const currentPositions = elements.map(()=>[0,0]);

  const update = ()=>{
    const {innerWidth,innerHeight} = window;
    elements.forEach((element,index) => {
      const position = currentPositions[index];

      const {top,left,width,height} = element.getBoundingClientRect();
      // relative to window
      // let x = range(clientX / window.innerWidth * 2 - 1,-1,1);
      // let y = range(clientY / window.innerHeight * 2 - 1,-1,1);
      // relative to element
      // const x = range((clientX - left) / width * 2 - 1,-1,1);
      // const y = range((clientY - top) / height * 2 - 1,-1,1);
      // relative to window, centered around element

      let x = range((clientX - left - width / 2) / innerWidth * 2,-1,1);
      let y = range((clientY - top - height / 2) / innerHeight * 2,-1,1);

      const [oldX,oldY] = position;

      position[0] += (x - position[0]) / smooth;
      position[1] += (y - position[1]) / smooth;

      let dirty = false;

      if(Math.abs(position[0] - oldX).toFixed(restThreshhold) > 0){
        element.style.setProperty('--proximity-x',position[0]);
        dirty = true;
      }

      if(Math.abs(position[1] - oldY).toFixed(restThreshhold) > 0){
        element.style.setProperty('--proximity-y',position[1]);
        dirty = true;
      }

      if(dirty){
        element.style.setProperty('--distance',Math.min(1,Math.sqrt(position[0] * position[0] + position[1] * position[1])));
      }
    });
  }

  const moveListener = subscribe(window,'mousemove',e=>{
    clientX = e.clientX;
    clientY = e.clientY;
  });

  const tick = time => {
    !destroyed&&requestAnimationFrame(tick);
    setGlobal&&updateGlobal();
    update();
  }

  if(elements.length || setGlobal){
    requestAnimationFrame(tick);
  }

  return ()=>{
    destroyed = true;
    moveListener();
  }
}